<div class="hr-calendar" test-id="hr-calendar">
  <gp-hr-calendar-header
    class="hr-calendar__header"
    [viewDate]="viewDate"
    (previous)="previousMonth()"
    (next)="nextMonth()"
    (monthSelected)="selectMonth($event)">
  </gp-hr-calendar-header>

  <div class="hr-calendar__table"
       role="grid"
       test-id="hr-calendar-grid"
       [attr.aria-label]="'HR_CALENDAR.calendar_grid' | translate:{month: monthLabel}">
    <div class="hr-calendar__weekdays" role="row">
      <div *ngFor="let weekday of month.weekdays"
           class="hr-calendar__weekday"
           role="columnheader"
           test-id="hr-calendar-weekday"
           [class.hr-calendar__weekday--weekend]="isWeekendDay(weekday)">
        {{ weekdayKey(weekday) | translate }}
      </div>
    </div>
    <div class="hr-calendar__weeks" role="rowgroup" test-id="hr-calendar-weeks">
      <div *ngFor="let week of month.weeks; trackBy: trackWeek"
           class="hr-calendar__week"
           role="row"
           test-id="hr-calendar-week">
        <gp-hr-calendar-day-cell
          *ngFor="let day of week.days; trackBy: trackDay"
          role="gridcell"
          [attr.test-id]="'hr-calendar-day-' + day.isoDate"
          [day]="day"
          [tags]="visibleTags(day)"
          [workSchedule]="workScheduleFor(day)">
        </gp-hr-calendar-day-cell>
      </div>
    </div>
  </div>
</div>
